import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pushQueue: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addPushNotification: (state, action) => {
      state.pushQueue.unshift({
        ...action.payload,
        timestamp: Date.now(),
      });
    },
    removePushNotification: (state, action) => {
      state.pushQueue = state.pushQueue.filter(
        (item) => item.id !== action.payload
      );
    },
    clearPushQueue: (state) => {
      state.pushQueue = [];
    },
  },
});

export const {
  addPushNotification,
  removePushNotification,
  clearPushQueue,
} = notificationSlice.actions;

export default notificationSlice.reducer;

export const selectPushQueue = (state) => state.notification.pushQueue;
